






























































































import { Vue, Component, Prop } from "vue-property-decorator";
import CardTitle from "../components/CardTitle.vue";

@Component({
  components: {
    CardTitle
  }
})
export default class Documents extends Vue {
  private titleParams: object;

  constructor() {
    super();
    this.titleParams = {
      title: "Documenti Utili",
      cols: "10",
      sm: "5",
      md: "5",
      lg: "4"
    };
  }

//   test() {
//     <%Session["Test"] = "Welcome Mamu";%>
// var session_value='<%=Session["Test"]%>'; 
// alert(session_value);
//   }
}
